import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#FFE3E3",
        // opacity: 0.14,
        borderRadius: '10px',
        margin: '2.5%',
        marginBottom: '1%',
        width: "95%",

        '& h5': {
            color: '#0a0e51',
            'font-family': 'Nunito',
            'font-size': '12px',
            'margin-left': '20px',
            'padding-left': '10px',
            'padding-right': '10px',
            marginTop: '5px',
            marginBottom: '5px'
        }

        ,
        "& h6": {
            color: '#0a0e51',
            'font-family': 'Nunito',
            'font-size': '15px',
            'margin-left': '20px',
            'padding-left': '10px',
            'padding-right': '10px',
            marginTop: '5px',
            marginBottom: '5px'


        },
    },

}));

export default function PlanDetailsComponent(props) {
    const classes = useStyles();
    let today = new Date().toISOString().slice(0, 10);
    console.log(props);
    return (

        <Grid container spacing={2} className={classes.root}>
            <Grid item xs={12} sm={6} md={4}>
                <h5>No Of Members</h5><h6>{props.planData.members}</h6>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                {isPolicy()}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                {planDurationHtml(props.planData.showStartDate, props.planData.duration, today)}
            </Grid>


        </Grid>

    );
}

function isPolicy() {
    if (localStorage.getItem("source") == 'mahindra') {
        return (<div><h5>Policy Tenure</h5><h6>1 Year</h6></div>)
    } else {
        return (<div></div>);
    }
}

function planDurationHtml(sendDefault, duration, today) {
    if (sendDefault) {
        return (<React.Fragment><h5>MediBuddy Plan Start Date</h5><h6>{today}</h6></React.Fragment>)
    } else {
        return (<React.Fragment><h5>Validity</h5><h6>{duration}</h6></React.Fragment>);
    }
}
